import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useRestrictModalNavigation = (
    show: boolean,
    onHashRemoved?: () => void
) => {
    const router = useRouter();
    const setModalHash = (modalId: string) => {
        window.history.replaceState(window.history.state, '', `#${modalId}`);
    };

    const handleClose = () => {
        if (onHashRemoved) onHashRemoved();
        clearModalHash();
    };
    useEffect(() => {
        if (show) {
            setModalHash('modal');
        } else {
            clearModalHash();
        }
    }, [show]);

    useEffect(() => {
        const handleHashChange = () => {
            const { hash } = window.location;
            if (!hash) if (onHashRemoved) onHashRemoved();
        };

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
            clearModalHash();
        };
    }, [router.asPath]);

    return { handleClose };
};

const clearModalHash = () => {
    const { protocol, host, pathname, search } = window.location;
    const newUrl = `${protocol}//${host}${pathname}${search}`;
    window.history.replaceState(window.history.state, document.title, newUrl);
};
